import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SVGComponent = function SVGComponent(props) {
  var style = props.style;
  return /*#__PURE__*/React.createElement(Svg, {
    style: style,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M11.3086 11.9979C10.2521 12.8973 8.88281 13.44 7.38671 13.44C4.04354 13.44 1.33337 10.7299 1.33337 7.38671C1.33337 4.04354 4.04354 1.33337 7.38671 1.33337C10.7299 1.33337 13.44 4.04354 13.44 7.38671C13.44 8.87377 12.9038 10.2356 12.0142 11.2894L14.9198 14.195L14.2127 14.9021L11.3086 11.9979ZM12.44 7.38671C12.44 10.1776 10.1776 12.44 7.38671 12.44C4.59583 12.44 2.33337 10.1776 2.33337 7.38671C2.33337 4.59583 4.59583 2.33337 7.38671 2.33337C10.1776 2.33337 12.44 4.59583 12.44 7.38671Z",
    fill: "black",
    fillOpacity: "0.54",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
};
export default SVGComponent;